import { render, staticRenderFns } from "./ClientTabReminders.vue?vue&type=template&id=8a938dd4&"
import script from "./ClientTabReminders.vue?vue&type=script&lang=js&"
export * from "./ClientTabReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports